import React, { Component } from "react";
import { Icon, Modal, Spin, AutoComplete } from "antd";
import { Translate } from "react-translated";
import axios from "axios";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class DashModal extends Component {
  state = {
    loading: true,
    agencies: [],
    value: "",
    open: false
  };
  componentDidMount = () => {
    axios.get("/api/vo_agencies").then((res) => {
      // new add
      const agencies = res.data;
      agencies.unshift({
        id: "",
        name: "All Agencies"
      });

      this.setState({
        loading: false,
        agencies
      });
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.showModal === false && this.props.showModal === true) {
      setTimeout(() => this.setState({ open: true }), 400);
    }

    if (prevProps.showModal === false && this.props.showModal === false) {
      setTimeout(() => this.setState({ open: false }));
    }
  }

  componentWillUnmount() {
    setTimeout(() => this.setState({ open: false }), 100);
  }

  agencySelect = (agency_id) => {
    // reset input field if `All Agencies` selected
    // if (agency_id === "") {
    //   this.setState({ value: "" });
    // }
    this.setState({ value: "" });
    this.props.hideModal();

    window.localStorage.vo_agency_id = agency_id;

    this.props.history.push("/dashboard");

    const { onSelectAgency } = this.props;
    onSelectAgency && onSelectAgency(agency_id);
  };

  onSelectAgency = (val) => {
    let item = this.state.agencies.find((agency) => agency.name === val);

    if (item) this.agencySelect(item.id);
  };

  onChange = (data, option) => {
    this.setState({ value: data });
  };

  render() {
    const { agencies, loading } = this.state;

    const vo_agency_id =
      "vo_agency_id" in window.localStorage &&
      window.localStorage.vo_agency_id !== ""
        ? parseInt(window.localStorage.vo_agency_id, 10)
        : "";

    let defaultAgency = agencies.find((agency) => agency.id === vo_agency_id);

    const dataSource = agencies.map((agency) => agency.name);

    return (
      <div style={{ marginBottom: 20 }}>
        <Modal
          title={<Translate text={`Dedicated Agency Dashboard`} />}
          visible={this.props.showModal}
          onOk={this.props.hideModal}
          onCancel={this.props.hideModal}
          footer={null}
        >
          <Spin indicator={antIcon} spinning={loading}>
            {/* <Select
              value={vo_agency_id}
              style={{ width: 220 }}
              // onChange={(val) => {
              //   this.agencySelect(val);
              // }}
              onSelect={(value, event) => this.agencySelect(value)}
            >
              <Option value={""}>
                <Translate text={`All Agencies`} />
              </Option>
              {agencies.map((agency, i) => (
                <Option key={i} value={+agency.id}>
                  {agency.name}
                </Option>
              ))}
            </Select> */}
            <AutoComplete
              style={{ width: "100%" }}
              dataSource={dataSource}
              placeholder="Select Agency"
              defaultValue={defaultAgency ? defaultAgency.name : ""}
              onSelect={this.onSelectAgency}
              onSearch={this.onSelectAgency}
              allowClear
              filterOption={(inputValue, option) =>
                option.props.children
                  .toUpperCase()
                  .indexOf(inputValue.toUpperCase()) !== -1
              }
              value={this.state.value}
              onChange={this.onChange}
              open={this.state.open}
            />
          </Spin>
        </Modal>
      </div>
    );
  }
}

export default DashModal;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/vonboard/dedicated-agency-modal.js